import {datadogRum} from '@datadog/browser-rum';
import {datadogLogs} from '@datadog/browser-logs';

if (dd.clientToken) {
    datadogRum.init({
        clientToken: window.dd.clientToken,
        applicationId: window.dd.applicationId,
        // `site` refers to the Datadog site parameter of your organization
        // see https://docs.datadoghq.com/getting_started/site/
        site: 'datadoghq.eu',
        service: window.dd.service,
        env: window.dd.env,
        version: window.dd.version,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        trackingConsent: "granted",
        trackUserInteractions: true,
        defaultPrivacyLevel: 'mask-user-input',
        // Persist global context across page navigations for funnel analysis
        // @see https://docs.datadoghq.com/real_user_monitoring/application_monitoring/browser/advanced_configuration/?tab=npm#global-context
        storeContextsAcrossPages: true,
        // https://docs.datadoghq.com/real_user_monitoring/correlate_with_other_telemetry/apm/?tab=browserrum#opentelemetry-support
        allowedTracingUrls: [/https:\/\/[^/]*\.officinemoto\.com/],
        // Override default view names with semantic names for funnel analysis
        // @see https://docs.datadoghq.com/real_user_monitoring/application_monitoring/browser/advanced_configuration/?tab=npm#override-default-rum-view-names
        beforeSend: (event) => {
            if (event.type === 'view') {
                // Use explicit view name if set, otherwise fall back to HTML title
                event.view.name = window.dd.viewName || document.title || event.view.name;
            }
            return true;
        },
    });

    datadogLogs.init({
        clientToken: window.dd.clientToken,
        service: window.dd.service,
        env: window.dd.env,
        version: window.dd.version,
        site: 'datadoghq.eu',
        forwardErrorsToLogs: true,
        sessionSampleRate: 100,
        trackingConsent: "granted",
    });

    // Set user tracking with enhanced attributes (id, name, email, role, staff, user_type)
    if (window.dd.user) {
        datadogLogs.logger.debug('Set user in Datadog', window.dd.user);
        datadogRum.setUser(window.dd.user);
    }

    // Set global context with route data for funnel analysis when route is in context
    // Includes: channel, source_region, target_region, urban, discounted, price_range, etc.
    if (window.dd.routeContext) {
        datadogRum.setGlobalContext({route: window.dd.routeContext});
    }
}
